import { render, staticRenderFns } from "./AttachmentTypeList.vue?vue&type=template&id=ae4b5934&"
import script from "./AttachmentTypeList.js?vue&type=script&lang=js&"
export * from "./AttachmentTypeList.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports